module.exports = __webpack_public_path__ + "static/img/1200.76d0c41.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qingye/1200.png
// module id = DYjK
// module chunks = 1